import { STATE_CONSTANTS_PROGRAM } from "../../../utils/useConstantState";

const ProgramClickAddOn = (item, setAddOn, type) => {
  try {
    setAddOn((prevState) => {
      let newArray = [...prevState];
      let index = newArray.findIndex((row) => {
        return row._id === item._id;
      });

      if (index >= 0) {
        if (type === "WATER") {
          const isSelf = newArray[index];

          if (isSelf?.isSelected) {
            newArray[index].isSelected = false;
          } else {
            newArray.forEach((water) => {
              water.isSelected = false;
            });

            newArray[index].isSelected = !newArray[index].isSelected;
          }
        }
        if (type !== "WATER") {
          newArray[index].isSelected = !newArray[index].isSelected;
        }
      } else {
        newArray.push({
          ...item,
          isSelected: true,
        });
      }
      return [...newArray];
    });
    // setSelected((prev) => {
    //   let temp = prev;
    //   const findIndex = temp.findIndex((row) => {
    //     return row._id === item._id;
    //   });
    //   if (findIndex >= 0) {
    //     temp.splice(findIndex, 1);
    //   } else {
    //     temp.push(item);
    //   }
    //   return [...temp];
    // });
  } catch (error) {
    console.error("ProgramClickAddOn  :", error);
  }
};

export default ProgramClickAddOn;
